/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_LiveInputs */

const en_header_live = /** @type {(inputs: Header_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LIVE`)
};

const id_header_live = /** @type {(inputs: Header_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LIVE`)
};

/**
* | output |
* | --- |
* | "LIVE" |
*
* @param {Header_LiveInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const header_live = /** @type {((inputs?: Header_LiveInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_LiveInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_header_live(inputs)
	return en_header_live(inputs)
});